import React, { useEffect, useState } from "react";
import styles from "./ApiLoadingLabels.module.scss";
import Loader from "../loader";
import { useDomainContext } from "@hooks/useDomainContext";

let loadingMessages = [
    "Working on it…",
    "Almost ready…",
    "Finalizing results…",
];

export const ApiLoadingLabels = ({
    withLoading,
}: {
    withLoading?: boolean;
}) => {
    const { category } = useDomainContext();
    if (category?.config?.apiLoadingMessages?.length) {
        loadingMessages = category.config.apiLoadingMessages;
    }
    const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
    const [isAnimating, setIsAnimating] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            setIsAnimating(true);
            setTimeout(() => {
                setCurrentMessageIndex(
                    (prevIndex) => (prevIndex + 1) % loadingMessages.length,
                );
                setIsAnimating(false);
            }, 300); // Wait for slide-up animation to complete
        }, 2000); // Change message every 2 seconds

        return () => clearInterval(interval);
    }, []);

    return (
        <div className={styles["loading-container"]}>
            <div className={styles["label-wrapper"]}>
                <div
                    key={currentMessageIndex}
                    className={`${styles["loading-label"]} ${
                        isAnimating ? styles["slide-up"] : styles["slide-in"]
                    }`}
                >
                    {loadingMessages[currentMessageIndex]}
                </div>
                {withLoading && (
                    <Loader
                        className={styles["api-loading-wrapper"]}
                        size={30}
                    />
                )}
            </div>
        </div>
    );
};
